import { c as _c } from "react/compiler-runtime";
import { mainnet } from "viem/chains";
import { MEMES_CONTRACT } from "@/constants/constants";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { getDimensionsFromMetadata, getFileMimeTypeFromMetadata, getFileTypeFromMetadata } from "@/helpers/nft.helpers";
import NowMintingCountdown from "./NowMintingCountdown";
import NowMintingDetailsAccordion from "./NowMintingDetailsAccordion";
import NowMintingHeader from "./NowMintingHeader";
import NowMintingStatsGrid from "./NowMintingStatsGrid";
interface NowMintingDetailsProps {
  readonly nft: NFTWithMemesExtendedData;
}
export default function NowMintingDetails(t0) {
  const $ = _c(29);
  const {
    nft
  } = t0;
  const formatEth = _temp;
  const floorPrice = formatEth(nft.floor_price);
  let t1;
  if ($[0] !== nft.metadata) {
    t1 = getFileMimeTypeFromMetadata(nft.metadata);
    $[0] = nft.metadata;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fileMimeType = t1;
  let t2;
  if ($[2] !== fileMimeType || $[3] !== nft.artist || $[4] !== nft.artist_seize_handle || $[5] !== nft.id || $[6] !== nft.name) {
    t2 = <NowMintingHeader cardNumber={nft.id} title={nft.name} artistHandle={nft.artist_seize_handle} artistName={nft.artist} mediaMimeType={fileMimeType} />;
    $[2] = fileMimeType;
    $[3] = nft.artist;
    $[4] = nft.artist_seize_handle;
    $[5] = nft.id;
    $[6] = nft.name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== floorPrice || $[9] !== nft.id) {
    t3 = <NowMintingStatsGrid nftId={nft.id} floorPrice={floorPrice} />;
    $[8] = floorPrice;
    $[9] = nft.id;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = nft.id;
  const t5 = nft.mint_date;
  let t6;
  if ($[11] !== nft.metadata) {
    t6 = getFileTypeFromMetadata(nft.metadata);
    $[11] = nft.metadata;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== nft.metadata) {
    t7 = getDimensionsFromMetadata(nft.metadata);
    $[13] = nft.metadata;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== nft.collection || $[16] !== nft.id || $[17] !== nft.mint_date || $[18] !== nft.season || $[19] !== t6 || $[20] !== t7) {
    t8 = <NowMintingDetailsAccordion nftId={t4} mintDate={t5} fileType={t6} dimensions={t7} collection={nft.collection} season={nft.season} />;
    $[15] = nft.collection;
    $[16] = nft.id;
    $[17] = nft.mint_date;
    $[18] = nft.season;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== nft.id) {
    t9 = <NowMintingCountdown nftId={nft.id} contract={MEMES_CONTRACT} chainId={mainnet.id} />;
    $[22] = nft.id;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t2 || $[25] !== t3 || $[26] !== t8 || $[27] !== t9) {
    t10 = <div className="tw-w-full"><div className="tw-flex tw-flex-col tw-gap-5">{t2}{t3}{t8}{t9}</div></div>;
    $[24] = t2;
    $[25] = t3;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function _temp(value) {
  if (value <= 0) {
    return "N/A";
  }
  return `${Number.parseFloat(value.toFixed(5))} ETH`;
}